import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_MODES } from './device-detection.constants';
import { ClientManagerService } from '../client-manager/client-manager.service';
import { getBrowser, getOS } from '../../utilities/device-utilities';

@Injectable()
export class DeviceContextInterceptor implements HttpInterceptor {
    private readonly browserInfo: string;
    private readonly osInfo: string;

    public constructor(private clientManagerService: ClientManagerService) {
        this.browserInfo = getBrowser();
        this.osInfo = getOS();
    }

    public intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        const appMode = this.getAppMode(); // check dynamically on each request
        const modifiedReq = req.clone({
            setHeaders: {
                'pace-os': this.osInfo,
                'pace-browser': this.browserInfo,
                'pace-mode': appMode,
            },
        });

        return next.handle(modifiedReq);
    }

    private getAppMode(): string {
        return this.clientManagerService.isPacePWAStandalone() ? APP_MODES.STANDALONE : APP_MODES.BROWSER;
    }
}
